import React, { useContext, useRef, useState } from "react";
import { userCan, getOrganization } from "../../../services/userRights.service";
import { postExternal } from "../../../services/api.service";
import { getReactAppExtranet } from "../../../services/utils.service";
import { tooltip } from "../../../services/message.service";
import { TranslationContext } from "../../../context/TranslationContext";
import { gtmPro } from "../../../services/gtmPro";

function trackAddToCart() {
  return; // Temp disabled; remove to enable cart GTM.

  try {
    gtmPro().ctaOfConfiguration({
      name: "extranet.config3d.config3d_finalize_button_add-to-cart",
      category: "configurateur",
      subcategory: "Finalisation",
      type: "cta",
      from: "bottom"
    }, { template: "configurateur", subtemplate: "finalisation" });
  } catch (_) {
    // GTM initialization must not block the cart request.
  }
}

export default function AddToCartButton({ configuration, family, blocked }) {
  const t = useContext(TranslationContext);
  const inFlight = useRef(false);
  const [pending, setPending] = useState(false);
  const translate = (key, fallback) => {
    const value = t(key);
    return value && value !== key ? value : fallback;
  };
  const monument = configuration.monument;
  const status = configuration.status || {};
  const prices = configuration.price || {};
  const buying = prices.discounted == null ? prices.buying : prices.discounted;
  const selling = prices.custom > 0 ? prices.custom : prices.selling;

  if (!userCan.cart() || family || configuration.configType === "family" || configuration.quoteId ||
      configuration.configurationMode === "frame_veneer" || configuration.order?.stockId?.trim() ||
      !monument?.reference || [monument.kind, monument.category].some(kind => ["ACC", "SEM", "PLT"].includes(kind))) {
    return null;
  }

  const disabled = pending || blocked || !configuration.reference ||
    !configuration.project?.customer?.trim() || status.completedAt || status.validatedAt ||
    status.prevalidatedAt || status.archivedAt ||
    !Number.isFinite(buying) || buying <= 0 || !Number.isFinite(selling) || selling <= 0;

  const addToCart = async () => {
    if (!userCan.cart() || inFlight.current || disabled) return;
    inFlight.current = true;
    setPending(true);
    trackAddToCart();
    try {
      const result = await postExternal("cart/items", {
        configuration_reference: String(configuration.reference),
        client_id: getOrganization().reference
      });
      if (!result?.cart) {
        throw new Error(result?.error_description || translate("config3d_cart_error", "Impossible d'ajouter la configuration au panier."));
      }
      window.parent.postMessage({
        action: "cart.updated",
        cart: { id: result.cart.id, items_count: result.cart.items_count },
        open: true
      }, new URL(getReactAppExtranet()).origin);
      tooltip("success", translate("config3d_cart_added", "Configuration ajoutée au panier."), 2500);
    } catch (error) {
      tooltip("error", error.message || translate("config3d_cart_error", "Impossible d'ajouter la configuration au panier."), 5000);
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  return (
    <button
      type="button"
      className="AddToCart button-secondary button-medium text-dark"
      style={{ flex: "1 1 140px" }}
      disabled={!!disabled}
      aria-busy={pending}
      onClick={addToCart}>
      <span className="cart-icon icon-large text-dark-icon" aria-hidden="true"></span>
      <span>{pending
        ? translate("config3d_cart_adding", "Ajout en cours…")
        : translate("config3d_finalize_button_add-to-cart", "Ajouter au panier")}</span>
    </button>
  );
}
